import {
  FinalRiskRating,
  ProviderActivityStatus,
  ProviderApprovalStatus,
  ProviderPriority,
  SupplierUsage,
} from '@app/src/types/categories'
import { ActorType, ProductMappingStatus, ProductStatus } from '@app/src/types/product'

// Stored enum members whose own translated label reads as an absence ("Not selected", "Not set",
// "No risk assessment"). The MRT tables show the shared Empty placeholder for these instead, so a
// cell that holds one of them looks the same as a cell that holds nothing at all.
const emptyEquivalentValues = new Set<string>([
  ProviderActivityStatus.NotSelected,
  ProviderApprovalStatus.NotSelected,
  ProviderPriority.NotSelected,
  SupplierUsage.NotSelected,
  FinalRiskRating.NotSelected,
  ProductStatus.NotSelected,
  ProductMappingStatus.NotSelected,
  ActorType.NotSet,
])

export const isEmptyEquivalentValue = (value?: string | null): boolean =>
  value !== undefined && value !== null && emptyEquivalentValues.has(value)
